import React from 'react';
import { styles } from './DisplayModelOptionStatus.css';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import CircleIcon from '@jbhi-fi/lanyard-ui/components/Icons/Circle';

export const DisplayModelOptionStatus = () => {
  return (
    <span className={styles.container}>
      <div className={styles.circleContainer}>
        <CircleIcon color={palette.success.main} />
      </div>
      <p className={styles.text} data-testid="localisation-view-display-model">
        View display model & order in-store
      </p>
    </span>
  );
};
